const messages = {
  title: "Moltiplicatore bonus",
  bandBonusTitle: "Bonus per pneumatico con moltiplicatore",
  amountLabel: "Numero min. di pneumatici (*)",
  label: "Moltiplicatore bonus",
  desc: "Numero di pneumatici Bridgestone e Firestone. Non è previsto alcun bonus in euro sui pneumatici Firestone.",
  goals: {
    loyal: "Fedele",
    bronze: "Bronzo",
    silver: "Argento",
    gold: "Oro",
    platinum: "Platino",
  },
  andMore: "e oltre",
  chooseTarget: "Seleziona",
  selectTarget: "Seleziona qui il tuo obiettivo annuale {year}:",
  multiplication: "Il bonus viene moltiplicato per <b>{factor}</b>",
  minTyres: "<b>Minimo:</b> {tyre} pneumatici",
};

export default {
  messages,
};
